// MongoObjectIdMatcher.jsx
'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';

import withRouter from '../component/WithRouter.jsx';
import UniversalComponent from '../component/UniversalComponent.jsx';

import env from '../resource/env.js';
import defaults from '../resource/defaults.js';

const mongoObjectIdRegexPattern = env.MONGO_OBJECT_ID_REGEX_PATTERN;

export const MongoObjectIdMatcher = ({
  paramKeys = defaults.EMPTY_ARRAY,
  children = null,
  staticContext = defaults.EMPTY_OBJECT,
}) => {
  const params = useParams();
  const mongoObjectIdRegex = new RegExp(mongoObjectIdRegexPattern, 'i');
  const isEveryKeyValid = paramKeys.every(key =>
    mongoObjectIdRegex.test(params?.[key])
  );

  if (!isEveryKeyValid) {
    staticContext.error = new Error(
      JSON.stringify({ status: 404, message: 'Invalid object id.' })
    );
    return (
      <UniversalComponent
        filename="Container_NotFoundPage"
        importer={
          /* #__LOADABLE__ */ () => import('../container/NotFoundPage.js')
        }
      />
    );
  }

  return children;
};

MongoObjectIdMatcher.propTypes = {
  staticContext: PropTypes.object,
  paramKeys: PropTypes.array,
  children: PropTypes.node,
};

export default withRouter(MongoObjectIdMatcher);
